export const FAILED = 'Failed';
export const VIEWED = 'Viewed';
export const SENT = 'Sent';
export const PAID = 'Paid';
export const EMPTY = '';

export type invoiceStatusType = typeof FAILED | typeof VIEWED | typeof SENT | typeof PAID | typeof EMPTY;
